import { Tooltip } from 'antd'
import moment from 'moment-timezone'
import React from 'react'

function Footer() {
  const year = new Date().getFullYear()
  const lastUpdate = moment(process.env.REACT_APP_LAST_UPDATE)
  const lastUpdateCode = lastUpdate.tz('Europe/Berlin').format('DDD.HH.mm')

  return (
    <div className="text-center text-gray-500 space-y-2 shadow bg-gray-100 py-5">
      <div>MMEA © {year} - Designed by MMEA PTE LTD</div>
      <Tooltip
        placement="top"
        title={`Last Update is ${lastUpdate.fromNow()} at ${lastUpdate.format('YYYY-MM-DD HH:mm')}`}>
        <div>PMS ver. 2.{lastUpdateCode}</div>
      </Tooltip>
    </div>
  )
}

export default Footer
